const RATE_LIMIT_CODE = "GNR-00036";
const INVALID_TOKEN_CODE = "GNR-00037";
const EXPIRED_TOKEN_CODE = "GNR-00038";

export const getGenericResultErrorCodes = (errorOrResult) => {
  const messages =
    errorOrResult?.data?.error?.messages ||
    errorOrResult?.error?.messages ||
    {};
  return Object.keys(messages);
};

export const isPasswordResetRateLimited = (errorOrResult) =>
  getGenericResultErrorCodes(errorOrResult).includes(RATE_LIMIT_CODE);

export const isPasswordResetTokenInvalid = (errorOrResult) =>
  getGenericResultErrorCodes(errorOrResult).includes(INVALID_TOKEN_CODE);

export const isPasswordResetTokenExpired = (errorOrResult) =>
  getGenericResultErrorCodes(errorOrResult).includes(EXPIRED_TOKEN_CODE);
